// Upper; posting type 1 = "D"ebit  2 = "C"redit. See ApplicationFlagName.
export const JOURNAL_POST_TYPES = [
  {value: 1, label: 'Debit'},
  {value: 2, label: 'Credit'}
];